import type { InsurableItemStatus } from '@newfront-insurance/coverage-api';

import type { InsurableItem } from '../bff/types';

export function filterInsurableItemsByStatus(
  insurableItems: InsurableItem[],
  status: InsurableItemStatus.ACTIVE | InsurableItemStatus.INACTIVE,
): InsurableItem[] {
  return insurableItems.filter((insurableItem) => insurableItem.status.status === status);
}
